"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLiquidationDisplayForMode = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
/**
 * 将原始强平价适配币本位来展示 取倒数且互换up down
 * @param
 * @returns
 */
const parseLiquidationDisplayForMode = ({ mode, liquidationDown, liquidationUp, precision, }) => {
    let up = "";
    let down = "";
    if (mode === TradeAPILib_1.GridFuturesMode.coin_m) {
        const one = new trade_utils_lib_1.SafeDecimal(1);
        if (liquidationDown) {
            up = new trade_utils_lib_1.SafeDecimal(liquidationDown).equals(0)
                ? "0"
                : one
                    .div(new trade_utils_lib_1.SafeDecimal(liquidationDown))
                    .toDP(precision !== null && precision !== void 0 ? precision : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR)
                    .toFixed();
        }
        if (liquidationUp) {
            down = new trade_utils_lib_1.SafeDecimal(liquidationUp).equals(0)
                ? "0"
                : one
                    .div(new trade_utils_lib_1.SafeDecimal(liquidationUp))
                    .toDP(precision !== null && precision !== void 0 ? precision : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
                    .toFixed();
        }
    }
    else {
        up = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(liquidationUp, precision || 10, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
        down = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(liquidationDown, precision || 10, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    }
    return { up, down };
};
exports.parseLiquidationDisplayForMode = parseLiquidationDisplayForMode;
